import React from 'react'
import { StyledVideo } from './styled'

const Video = (props) => {
    React.useEffect(() => {
        console.log('props:>> ', props)
    },[])
    return (
        <StyledVideo src={`https://www.youtube.com/embed/${props?.video}`} frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></StyledVideo>
        // <StyledVideo id="my-video" controls>
        //     <source src={props.video.url} type="video/mp4"/>
        //         Your browser does not support HTML5 video.
        // </StyledVideo>
    )
}

export default Video